module.exports = __webpack_public_path__ + "static/media/aamaStory.ced3450b.ogg";